import merge from "lodash/merge"
import metadataParser from "markdown-yaml-metadata-parser"
import queryString from "querystring"

export const convertSpecialCharacter = (str: string) => {
  const arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' } // 提出
  type arrEntitiesKeys = keyof typeof arrEntities
  return str.replace(
    /&(lt|gt|nbsp|amp|quot);/gi,
    (all, t: arrEntitiesKeys) => arrEntities[t]
  )
}

export const formatDate = (date: string) => {
  const newDate = new Date(date)
  return `${newDate.getFullYear()}年${
    newDate.getMonth() + 1
  }月${newDate.getDate()}日`
}

export const trimProps = (props: any) => {
  const copyProps = { ...props }
  for (const key in copyProps) {
    if (Object.prototype.hasOwnProperty.call(copyProps, key)) {
      if (typeof copyProps[key] === "string") {
        copyProps[key] = copyProps[key].trim()
      }
    }
  }
  return copyProps
}

export const mergeNomalDataAndFileData = (props: any) => {
  if (!props.fillInMethod || !props.file) return props
  const isUploadFile = props.fillInMethod === "uploadFile"
  const { metadata = {}, content = "" } = isUploadFile
    ? metadataParser(props.file.localFile?.internal?.content)
    : {}

  return merge(
    { ...props },
    isUploadFile && {
      ...metadata,
      body: content,
      author: {
        name: metadata.author?.join(" "),
        description: "",
      },
    }
  )
}

export const getLinkWithPathPrefix = (link: string) => {
  const prefix = "/"

  if (link.startsWith("http") || link.startsWith(prefix)) {
    return link
  }

  link = link
    .replace(/^\/?blog-cn\/?/, "/blog/")
    .replace(/^\/?cases-cn\/?/, "/case/")

  return link.startsWith("/")
    ? `${prefix}${link.substring(1)}`
    : `${prefix}${link}`
}

export const getQueryStringParams = () => {
  const qs = window.location.search.substring(1)
  return queryString.parse(qs)
}
